import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import OutsideClickHandler from 'react-outside-click-handler'
import _ from 'lodash'

import './style.scss'

export default class Header extends Component {
    static propTypes = {
        compareYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        data: PropTypes.array,
        handleCompareYearChange: PropTypes.func.isRequired,
        handleSampleYearChange: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        sampleYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        setYears: PropTypes.func.isRequired,
        tableType: PropTypes.string.isRequired,
        translates: PropTypes.shape({
            compareYear: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            sampleYear: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            yearDevelopment: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            dropdownActive: null,
        }
    }

    handleShiftYearsLeft = () => {
        const { id, compareYear, sampleYear, setYears, data, tableType } = this.props

        const syObjIndex = _.findIndex(data, { year: sampleYear }) // Index of object containing sample year
        const cyObjIndex = _.findIndex(data, { year: compareYear }) // Index of object containing compare year

        if (syObjIndex >= data.length - 1 || cyObjIndex >= data.length - 1) return null

        const newSampleYear = _.get(data, `[${syObjIndex + 1}].year`, null)
        const newCompareYear = _.get(data, `[${cyObjIndex + 1}].year`, null)

        setYears(id, tableType, newCompareYear, newSampleYear)
        return null
    }

    handleShiftYearsRight = () => {
        const { id, compareYear, sampleYear, setYears, data, tableType } = this.props

        const syObjIndex = _.findIndex(data, { year: sampleYear }) // Index of object containing sample year
        const cyObjIndex = _.findIndex(data, { year: compareYear }) // Index of object containing compare year

        if (syObjIndex <= 0 || cyObjIndex <= 0) return null

        const newSampleYear = _.get(data, `[${syObjIndex - 1}].year`, null)
        const newCompareYear = _.get(data, `[${cyObjIndex - 1}].year`, null)

        setYears(id, tableType, newCompareYear, newSampleYear)
        return null
    }

    handleDropdownRowClick = (year, dropdownType) => {
        const { id, sampleYear, compareYear, handleCompareYearChange, handleSampleYearChange, setYears, tableType } =
            this.props

        if (dropdownType === 'cyDropdown') {
            // If the selected year is the same as sampleYear - switch both years
            if (year === sampleYear) {
                setYears(id, tableType, sampleYear, compareYear)
            } else {
                handleCompareYearChange(id, tableType, year)
            }
        } else if (dropdownType === 'syDropdown') {
            // If the selected year is the same as compareYear - switch both years
            if (year === compareYear) {
                setYears(id, tableType, sampleYear, compareYear)
            } else {
                handleSampleYearChange(id, tableType, year)
            }
        }

        this.setState({ dropdownActive: null })
        return null
    }

    handleDropdownClick = (selector, dropdownActive) => () => {
        if (dropdownActive === selector) this.setState({ dropdownActive: null })
        else this.setState({ dropdownActive: selector })
    }

    handleCloseDropdown = () => {
        this.setState({ dropdownActive: null })
    }

    render() {
        const { data, translates, compareYear, sampleYear } = this.props
        const { dropdownActive } = this.state

        return (
            <div className={'result-column-header-content'}>
                <div className={'rc-years-container'}>
                    <button className={'shift-years-btn left'} onClick={() => this.handleShiftYearsLeft()} />
                    <div className={'rc-years'}>
                        <div className={'rc-compare-year'}>
                            <span className={'rc-year-value'}>
                                {compareYear || '----'}
                                <OutsideClickHandler
                                    disabled={dropdownActive !== 'cyDropdown'}
                                    onOutsideClick={() => this.handleCloseDropdown()}
                                >
                                    <button
                                        onClick={this.handleDropdownClick('cyDropdown', dropdownActive)}
                                        className={'dropdown-btn'}
                                    />
                                    <div
                                        className={classnames(
                                            'dropdown-menu',
                                            dropdownActive === 'cyDropdown' && 'active'
                                        )}
                                    >
                                        {_.map(data, (row, index) => (
                                            <div
                                                key={`rc-dropdown-${row.year || index}-row`}
                                                className={classnames('dropdown-row')}
                                                onClick={() =>
                                                    this.handleDropdownRowClick(_.get(row, 'year', null), 'cyDropdown')
                                                }
                                            >
                                                {_.get(row, 'year')}
                                            </div>
                                        ))}
                                    </div>
                                </OutsideClickHandler>
                            </span>
                            <span className={'rc-year-label'}>{translates.compareYear}</span>
                        </div>
                        <div className={'rc-sample-year'}>
                            <span className={'rc-year-value'}>
                                {sampleYear || '----'}
                                <OutsideClickHandler
                                    disabled={dropdownActive !== 'syDropdown'}
                                    onOutsideClick={() => this.handleCloseDropdown()}
                                >
                                    <button
                                        onClick={this.handleDropdownClick('syDropdown', dropdownActive)}
                                        className={'dropdown-btn'}
                                    />
                                    <div
                                        className={classnames(
                                            'dropdown-menu',
                                            dropdownActive === 'syDropdown' && 'active'
                                        )}
                                    >
                                        {_.map(data, (row, index) => (
                                            <div
                                                key={`rc-dropdown-${row.year || index}-row`}
                                                className={classnames('dropdown-row')}
                                                onClick={() =>
                                                    this.handleDropdownRowClick(_.get(row, 'year', null), 'syDropdown')
                                                }
                                            >
                                                {_.get(row, 'year')}
                                            </div>
                                        ))}
                                    </div>
                                </OutsideClickHandler>
                            </span>
                            <span className={'rc-year-label'}>{translates.sampleYear}</span>
                        </div>
                    </div>
                    <button className={'shift-years-btn right'} onClick={() => this.handleShiftYearsRight()} />
                </div>
                <div className={'rc-texts-container'}>
                    <span className={'rc-column-title'}>{translates.yearDevelopment}</span>
                    <span className={'rc-column-units'}>{'( % )'}</span>
                </div>
            </div>
        )
    }
}
